<template>
  <div id="Error">
        <div class="info">
            <strong>서비스 작업 공지</strong>
            <div>
              <span>{{workNotice.startDt}} ~ {{workNotice.endDt}}</span>
              <p>{{workNotice.cntn}}</p>
            </div>
        </div>
    </div>
</template>
<script>
// import workNoticeJson from '../assets/js/worknotice.js'
// var workNoticeJson = () => import(/*webpackChunkName: "worknotice"*/ '@/assets/js/worknotice.js')
import axios from 'axios' 

export default {
  data() {
    return {
      workNotice: {}
    };
  },
  methods: {
    chkWorkNotice() {
      var that = this;
      axios.get('/worknotice.json').then(function(resonse) {
            var workYn = resonse.data.workYn;
            if(workYn != 'Y') {
                location.href = "/";
            } else {
              that.workNotice = resonse.data;
            }
          })
          .catch(function(error) {
              console.log(error);
          });
    }
  },
  created: function() {
    this.chkWorkNotice()
  },
  updated: function() {
    this.chkWorkNotice()
  }
};
</script>